import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from 'lucide-react';
import { LanguageSelector } from './LanguageSelector';

export const Footer = ({ onAboutClick, onHomeClick }) => {
  const { t } = useTranslation();
  return (
    <footer className="bg-levelup-dark text-white py-8 mt-auto w-full">
      <div className="w-full px-4 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
          <div className="flex items-center space-x-3">
            <img src="/technofocus-white.png" alt="Technofocus" className="h-5 brightness-0 invert" />
            <span className="text-levelup-accent font-bold">|</span>
            <img src="/logo-levelup.png" alt="LevelUp" className="h-5" />
            <span className="text-levelup-accent font-bold">|</span>
            <img src="/ms-levelup-logo.svg" alt="Sponsored by Microsoft" className="h-6" />
          </div>

          <div className="flex flex-wrap gap-4 md:gap-6 text-sm">
            <button
              onClick={onHomeClick}
              className="text-gray-300 hover:text-levelup-accent transition-colors"
              data-testid="footer-home-link"
            >
              {t('nav.home')}
            </button>
            <button
              onClick={onAboutClick}
              className="text-gray-300 hover:text-levelup-accent transition-colors"
              data-testid="footer-about-link"
            >
              {t('footer.aboutSkillingBox')}
            </button>
            <a
              href="https://skillupwithlevelup.com"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-gray-300 hover:text-levelup-accent transition-colors"
              data-testid="footer-levelup-link"
            >
              <ExternalLink size={13} />
              {t('footer.levelUpHome')}
            </a>
            <a href="https://skillupwithlevelup.com/guest-support" target="_blank" rel="noopener noreferrer"
              className="text-gray-300 hover:text-levelup-accent transition-colors">
              {t('footer.support')}
            </a>
            <a href="https://skillupwithlevelup.com/termsofuse" target="_blank" rel="noopener noreferrer"
              className="text-gray-300 hover:text-levelup-accent transition-colors">
              {t('footer.termsOfUse')}
            </a>
            <a href="https://technofocus.ai/privacy" target="_blank" rel="noopener noreferrer"
              className="text-gray-300 hover:text-levelup-accent transition-colors">
              {t('footer.privacyStatement')}
            </a>
            <LanguageSelector />
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-gray-700 text-center text-sm text-gray-400">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </div>
      </div>
    </footer>
  );
};
